import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import WarningDialog from "../../../components/WarningDialog";
import PasswordDialog from "../../../components/PasswordDialog";
import API from '../../../api';
import { startToast, updateToastError, updateToastSuccess } from "../../../utils/notification-loading";

const itemStyle = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#2e2e2e",
  borderRadius: "10px",
  gap: 2,
  p: 2,
  "& .dot": {
    width: 13,
    height: 13,
    borderRadius: "50%",
    position: "absolute",
    top: 10,
    right: 10,
  },
  "& .MuiTypography-root": { fontSize: 20, fontWeight: 600 },
  "& .MuiTypography-root span": { fontWeight: 300, color: "#459095" },
};

const DevicesList = ({ devices = [], setDevices }) => {
  const [warningOpen, setWarningOpen] = useState(false);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const handleDeleteClick = (device) => {
    setSelectedDevice(device);
    setWarningOpen(true);
  };

  const handleWarningCheck = (value) => {
    if (value) {
      setWarningOpen(false);
      setPasswordOpen(true);
    }
  };

  const handlePasswordConfirm = (password) => {
    
    
    
    startToast();
    API.emailSupportDeleteLecs({matricola: selectedDevice.matricola, pwd: password}).then((res) => {
      updateToastSuccess("Successfull!")
    }).catch((err) => {
      updateToastError(err)
    })
    setSelectedDevice(null);
  };

  if (devices.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Typography variant="h3">No devices found</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        height={"100%"}
        overflow={"auto"}
        sx={{
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
        }}
      >
        <Stack direction={"column"} spacing={2}>
          {devices.map((device, i) => (
            <Box key={i} sx={itemStyle}>
              <Box className="dot" sx={{ backgroundColor: device.status ? "green" : "red" }} />
              <Stack direction={"row"} spacing={2}>
                <Stack direction={"column"} spacing={1} width={"50%"}>
                  <Typography>Serial Number: <span>{device.matricola}</span></Typography>
                  {device.mac && <Typography>MAC: <span>{device.mac}</span></Typography>}
                  {device.ip && <Typography>IP: <span>{device.ip}</span></Typography>}
                  {device.dns && <Typography>DNS: <span>{device?.dns?.join(", ")}</span></Typography>}
                  {device.gateway && <Typography>Gateway: <span>{device.gateway}</span></Typography>}
                </Stack>
                <Stack direction={"column"} spacing={1} width={"50%"}>
                  <Typography>Name: <span>{device.nomeLecs ?? "-"}</span></Typography>
                  <Typography>Hardware: <span>{device.tipoLecs ?? "-"}</span></Typography>
                  <Typography>License Code: <span>{device.licenza ?? "-"}</span></Typography>
                  <Typography>Maximum Users: <span>{device.secondarylimit ?? "-"}</span></Typography>
                  <Typography>Admin Email: <span>{device.adminEmail ?? "-"}</span></Typography>
                </Stack>
              </Stack>

              <Button
                variant="outlined"
                color="error"
                size="small"
                sx={{ alignSelf: "flex-start", mt: 1 }}
                onClick={() => handleDeleteClick(device)}
              >
                DELETE
              </Button>
            </Box>
          ))}
        </Stack>
      </Box>

      <WarningDialog
        open={warningOpen}
        setOpen={setWarningOpen}
        setCheck={handleWarningCheck}
        message={`Are you sure you want to delete device "${selectedDevice?.nomeLecs}"? This action will submit a support ticket to support@cyberevolution.it requesting the deletion of the LECS device.`}
      />

      <PasswordDialog
        open={passwordOpen}
        setOpen={setPasswordOpen}
        onConfirm={handlePasswordConfirm}
      />
    </>
  );
};

export default DevicesList;